(() => {
  const initialise = (root) => {
    root.querySelectorAll('[data-thornvella-login]').forEach((form) => {
      if (form.dataset.accountInitialised === 'true') return;
      form.dataset.accountInitialised = 'true';
      const returnField = form.querySelector('[name="return_to"]');
      const target = new URL(returnField.value, window.location.origin);
      const current = new URL(window.location.href);
      const themeId = current.searchParams.get('preview_theme_id');
      if (themeId && /^\d+$/.test(themeId)) target.searchParams.set('preview_theme_id', themeId);
      returnField.value = target.pathname + target.search;
    });
    root.querySelectorAll('.tv-account__nav').forEach((nav) => {
      if (nav.dataset.tabsInitialised === 'true') return;
      const dashboard = nav.nextElementSibling;
      if (!dashboard?.classList.contains('tv-account__dashboard')) return;
      const tabs = [...nav.querySelectorAll('a[href^="#"]')];
      const panels = tabs.map((tab) => dashboard.querySelector(tab.getAttribute('href')));
      if (panels.some((panel) => !panel)) return;
      nav.dataset.tabsInitialised = 'true';
      nav.setAttribute('role', 'tablist');
      dashboard.dataset.accountTabsReady = 'true';
      const select = (index, focus = false) => {
        tabs.forEach((tab, position) => {
          const selected = position === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          panels[position].hidden = !selected;
        });
        if (focus) tabs[index].focus();
      };
      const syncHash = () => {
        const index = tabs.findIndex((tab) => tab.hash === window.location.hash);
        select(index < 0 ? 0 : index);
      };
      const activate = (index, focus = false) => {
        const url = new URL(window.location.href);
        url.hash = tabs[index].hash;
        window.history.pushState(null, '', url);
        select(index, focus);
      };
      tabs.forEach((tab, index) => {
        tab.id = panels[index].id + 'Tab';
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[index].id);
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          activate(index);
        });
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (event.key === ' ') next = index;
          if (next === undefined) return;
          event.preventDefault();
          activate(next, true);
        });
      });
      window.addEventListener('hashchange', syncHash);
      window.addEventListener('popstate', syncHash);
      syncHash();
    });
    root.querySelectorAll('[data-account-refresh]').forEach((button) => {
      if (button.dataset.accountInitialised === 'true') return;
      button.dataset.accountInitialised = 'true';
      button.addEventListener('click', () => window.location.reload());
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
